export default "__VITE_ASSET__BSu0als8__"